"use client";

import React, { useState, useEffect, useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import { useDispatch } from "react-redux";

import { motion } from "framer-motion";

import {
  setInquiryPopup,
  setInquiryPopupObj,
} from "@/store/slices/inquirySlice";

import "./ProjectsSection.css";


export default function ProjectsSection({ propertylist, mergedData }) {
  const dispatch = useDispatch();

  const [isMobilescreen, setMobileScreen] = useState(false);

  const [mounted, setMounted] = useState(false);

  const projectsRef = useRef(null);
  const mobileProjectImages = {
    881: "/images/home/listing-banners/sarvam.png", // NB Sarvam
    887: "/images/home/listing-banners/parva.png", // NB Parva
    888: "/images/home/listing-banners/torre.png", // Stark Torre
  };
  useEffect(() => {
    setMounted(true);

    const checkScreen = () => {
      setMobileScreen(window.innerWidth <= 991);
    };

    checkScreen();

    window.addEventListener("resize", checkScreen);

    return () => {
      window.removeEventListener("resize", checkScreen);
    };
  }, []);
  useEffect(() => {
    if (!mounted) return;

    const cards = document.querySelectorAll(".fullscreen-project-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      {
        threshold: 0.4,
      },
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, [mounted]);
  if (!propertylist?.length) return null;
  console.log(mergedData)
  return (
    <>
      {mounted && (
        <section className="projects-fullscreen-wrapper" ref={projectsRef}>
          {mergedData.map((project, index) => (
            <motion.section
              key={project.project_id || index}
              className="fullscreen-project-card"
              initial="hidden"
              whileInView="visible"
              viewport={{
                amount: 0.4,
                once: false,
              }}
              variants={{
                hidden: {},
                visible: {},
              }}
              onViewportEnter={(e) => {
                e.target.classList.add("in-view");
              }}
              onViewportLeave={(e) => {
                e.target.classList.remove("in-view");
              }}
            >
              <Link href={project.slug} className="project-inner">
                <div className="project-bg">
                  {project.project_id == 880 ? (
                    <video
                      className="project-bg-media"
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="auto"
                    >
                      <source
                        src="/images/nb-palm/walkthrough.mp4"
                        type="video/mp4"
                      />
                    </video>
                  ) : (
                    <Image
                      src={
                        isMobilescreen &&
                          mobileProjectImages[project.project_id]
                          ? mobileProjectImages[project.project_id]
                          : `${project.banner_data.image_web_full}&h=1800&w=2400&q=100`
                      }
                      fill
                      priority={index === 0}
                      alt={project.project_title}
                    />
                  )}
                </div>

                <div className="project-overlay"></div>

                <div className="project-content">
                  {/* <div className="project-count">
                    <span>{(index + 1).toString().padStart(2, "0")}</span>

                    <span>{mergedData.length.toString().padStart(2, "0")}</span>
                  </div> */}
                  <div
                    className="flex-row j-c-sb w100 main-container project-details-flex"
                    style={{ marginTop: "auto" }}
                  >
                    <div className="project-details">
                      <div className="section-title">
                        <h2 className="white-color">{project.project_title}</h2>
                      </div>

                      <div className="project-meta">
                        {project.size_price && (
                          <div className="project-information-div">
                            <img src="/images/icon/building.svg" alt="" />

                            <p className="white-color">{project.size_price}</p>
                          </div>
                        )}

                        {project.location && (
                          <div className="project-information-div">
                            <img src="/images/icon/location.svg" alt="" />

                            <p className="white-color">{project.location}</p>
                          </div>
                        )}
                        {project.project_status && (
                          <div className="project-information-div">
                            <img src="/images/detail-icon/status.svg" alt="" style={{ filter: "unset" }} />

                            <p className="white-color">{project.project_status}</p>
                          </div>
                        )}
                      </div>

                      {/* <button
                      className={`reecosys-template-button button-style-secondary ${
                        isMobilescreen ? "w100" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();

                        dispatch(setInquiryPopup(true));

                        dispatch(setInquiryPopupObj(project));
                      }}
                    >
                      Inquire Now
                    </button> */}
                    </div>
                    <div style={{ marginTop: "auto" }}>
                      <button className="reecosys-template-button button-style-white">
                        <p>View Project</p>
                        <span className="material-symbols-outlined">
                          arrow_outward
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.section>
          ))}
        </section>
      )}
    </>
  );
}
